import i18n from '@/plugins/i18n';
export const forms = [
    {
        type: 'text',
        name: 'user_name',
        title: i18n.t('customer.remoteUsers.username'),
        rules: {required: true, min: 3},
        options: false,
        modal: ['username'],
        data: ['username',],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'select',
        name: 'auth',
        title: i18n.t('customer.remoteUsers.auth'),
        rules: {required: true},
        options: {
            data: [],
            track: 'authority_code',
            label: 'authority_name'
        },
        modal: ['auth_code'],
        data: ['auth_code',],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'text',
        name: 'email',
        title: i18n.t('customer.remoteUsers.email'),
        rules: {required: true, email: true},
        options: false,
        modal: ['email'],
        data: ['email',],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'masked',
        name: 'phone',
        title: i18n.t('customer.remoteUsers.phone'),
        rules: {required: true, regex: /^(\+\s\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/ },
        options: false,
        mask:'\+\ 11 (111) 111 1111',
        modal: ['phone'],
        data: ['phone',],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'text',
        name: 'name',
        title: i18n.t('customer.remoteUsers.name'),
        rules: {required: true, min: 3},
        options: false,
        modal: ['name'],
        data: ['name',],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'text',
        name: 'lastname',
        title: i18n.t('customer.remoteUsers.lastname'),
        rules: {required: true, min: 3},
        options: false,
        modal: ['lastname'],
        data: ['lastname',],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'password',
        name: 'password',
        is: 'passwordAgain',
        title: i18n.t('customer.remoteUsers.password'),
        rules: {required: true, min: 3},
        options: false,
        modal: ['password'],
        data: ['password',],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'password',
        name: 'passwordAgain',
        is: 'password',
        title: i18n.t('customer.remoteUsers.password'),
        rules: {required: true, min: 3, is:'password'},
        options: false,
        modal: ['passwordAgain'],
        data: ['passwordAgain',],
        additionalButton: false,
        checkBox: false
    },
    
 
]
export default forms;


// WEBPACK FOOTER //
// ./src/pages/Alarmsis/Account/forms/remoteUser.js